<ion-content>
  <ion-list>
    <ion-item (click)="closeModal()">
      Delete
    </ion-item>
  </ion-list>
</ion-content>